export default "__VITE_PUBLIC_ASSET__5e26f3bc__"